module.exports = __webpack_public_path__ + "img/scheduler.490a571b.svg";